import { presignedURLGet } from '../services';
import { useNavbarContext } from 'context/NavbarContext';

export default function useFileDownload() {
  const { downloadFile: downloadAs } = useNavbarContext();

  const downloadFile = async (file) => {
    let file_path = file?.file_path;
    let file_name = file?.display_name;
    let version_id = file?.version_id;
    let data = await presignedURLGet(file_path, version_id);
    let url = data?.data?.file_url;
    downloadAs(url, file_name);
  };

  return { downloadFile };
}
